<!-- 铺货 -->
<template>
  <div id="tablePage">
    <div id="SelectGoods">
      <el-table
        ref="tableData"
        :data="tableData"
        :height="tableHeight"
        v-loading="loading"
        >
        <template slot="empty" v-if="!loading">
          <div v-if="isNetWrong" class="no-datas">
            <div class="no-data-img">
              <img src="../../../../assets/images/no_data.png" alt="" style="width: 100%;">
            </div>
            <div class="no-data" style="margin-top: -15px !important; text-align: center;" @click="showData">加载失败,点击重试</div>
          </div>
          <div v-else class="no-datas">
            <div class="no-data-img">
              <img src="../../../../assets/images/no_data.png" alt="" style="width: 100%;">
            </div>
            <div class="no-data">暂无数据</div>
          </div>
        </template>
        <el-table-column type="index" label="序号" width="50">
        </el-table-column>
        <el-table-column prop="commodityName" label="交易品种">
        </el-table-column>
        <el-table-column prop="storageName" label="仓库名称">
        </el-table-column>
        <el-table-column prop="holdMargin" label="占用履约订金">
          <template slot-scope="scope">
            {{ Number(scope.row.holdMargin) | toThousands }}
          </template>
        </el-table-column>
        <el-table-column prop="avgPrice" label="持仓价">
          <template slot-scope="scope">
            {{ Number(scope.row.avgPrice) | toThousands1 }}
          </template>
        </el-table-column>
        <el-table-column prop="quantity" label="可铺数量">
        </el-table-column>
        <el-table-column prop="warehouseQuantity" label="仓单总数量">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div
              v-if="scope.row.quantity>0"
              style="display: flex;
      justify-content: center;"
            >
              <el-button type="text" @click="revoke(scope.row)">铺货</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        title="铺货"
        :visible.sync="dialogVisible"
        width="30%"
      >
        <el-row class="zr_dialog_input">
          <el-col :span="6"><div style="line-height:40px">商品</div></el-col>
          <el-col :span="18">
            <el-input v-model="transfer.commodityName" disabled placeholder="选中商品"></el-input>
          </el-col>
        </el-row>
        <el-row class="zr_dialog_input">
          <el-col :span="6"><div style="line-height:40px">铺货数量</div></el-col>
          <el-col :span="18">
            <el-input v-model="transfer.quantity" type="number" placeholder="铺货数量"></el-input>
          </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-button :disabled="zring" @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" :disabled="zring" @click="revokeConfirm">确认</el-button>
        </span>
      </el-dialog>
      <!-- 分页 -->
      <el-row v-if="pageData.total">
        <el-col :span="24" class="paginateWrap">
          <el-pagination
            popper-class="_popStyle"
            :current-page="pageData.currentPage"
            :page-sizes="pageData.pageSizes"
            :page-size="pageData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
/*global http protocol*/
import {
  mapGetters
} from 'vuex'
import {
  bus
} from '../../../../assets/js/trans/bus.js'
export default {
  name: 'SelectGoods',
  props: ['flag', 'page'],
  data() {
    return {
      tableHeight: 0,
      loading: false,
      tableData: [],
      // 是否撤单
      dialogVisible: false,
      // 分页
      pageData: {
        total: null,
        pageSizes: [5, 10, 20, 30, 40, 50, 60],
        pageSize: 20,
        currentPage: 1
      },
      // 选中的铺货
      selectGood: null,
      transfer: {
        commodityName: '',
        quantity: ''
      },
      zring: false
    }
  },
  computed: {
    ...mapGetters(['sessionInfoGetter', 'commodityStrategyGetter'])
  },
  watch: {
    flag() {
      protocol.param_getSpread.param.bsFlag = this.flag
      this.showData()
    }
  },
  created() {
    // 兄弟通信
    bus.$on('refreshData', () => {
      this.showData()
    })
    window.onresize = () => {
      this.$nextTick(() => {
        this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      })
    }
  },
  updated() {
    this.$nextTick(() => {
      this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      this.$refs['tableData'].doLayout()
    })
  },
  mounted() {
    this.showData()
  },
  methods: {
    // 分页
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.showData()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.showData()
    },
    // 订单展示
    showData() {
      this.loading = true
      // protocol.param_getSpread.param.firmId = this.sessionInfoGetter.firmId
      protocol.param_getSpread.param.page = this.pageData.currentPage - 1
      protocol.param_getSpread.param.size = '' + this.pageData.pageSize
      http.postFront1(protocol.param_getSpread).then(response => {
        if (response.data) {
          if (response.data && response.data.code == '0') {
            this.pageData.total = response.data.value.totalElements
            const arr = response.data.value.content
            this.judgeDataType(arr)
          }
        }
        this.loading = false
      })
    },
    // 判断数据类型
    judgeDataType(arr) {
      const that = this
      this.each(arr, function(arrIndex) {
        // 判断时间
        that.modifyTime(arrIndex, 'createTime')
        // 判断方向
        // that.modifyData(arrIndex, 'bsFlag', 'B', that.$t('message.Buy'), that.$t('message.Sell'))
      })
      this.tableData = arr
    },
    // 撤单
    revoke(obj) {
      this.dialogVisible = true
      this.selectGood = obj
      this.transfer.commodityName = obj.commodityName
    },
    // 铺货
    revokeConfirm() {
      const that = this
      if (this.transfer.quantity <= 0) {
        this.$message('委托数量需大于0')
        return
      }
      if (this.zring) {
        return
      } else {
        this.zring = true
      }

      if (this.transfer.quantity) {
        protocol.param_spreadGoods.param.commodityId = this.selectGood.commodityId
        protocol.param_spreadGoods.param.quantity = this.transfer.quantity

        protocol.param_spreadGoods.param.storageId = this.selectGood.storageId
        protocol.param_spreadGoods.param.warehouseId = this.selectGood.warehouseId
        http.postFront1(protocol.param_spreadGoods).then(response => {
          this.zring = false
          if (response.data) {
            const { code, message } = response.data
            if (code == '0') {
              this.$message('成功')
              this.transfer.commodityName = ''
              this.transfer.quantity = ''
              this.selectGood = null
              this.dialogVisible = false
              setTimeout(() => {
                that.showData()
              }, window.g.Interface_latency_Time && 800)
            } else {
              this.$message(message)
              this.transfer.commodityName = ''
              this.transfer.quantity = ''
              this.selectGood = null
              this.dialogVisible = false
            }
          }
        }).catch(() => {
          this.zring = false
        })
      } else {
        this.zring = false
        this.$message('请填写铺货数量')
      }
    },
    // 排序
    sortChange(column, prop, order) {
      if (column.order == 'ascending') {
        protocol.param_getSpread.param.sort[0].direction = 'ASC'
      } else {
        protocol.param_getSpread.param.sort[0].direction = 'DESC'
      }
      // protocol.param_getSpread.param.firmId = this.sessionInfoGetter.firmId
      if (column.column) {
        this.eachSortChange(column.column.property)
        http.postFront1(protocol.param_getSpread).then(response => {
          if (response.data) {
            if (response.data && response.data.code == '0') {
              this.pageData.total = response.data.value.totalElements
              const arr = response.data.value.content
              this.judgeDataType(arr)
            }
          }
        })
      }
    },
    // 分项排序
    eachSortChange(str) {
      return (protocol.param_getSpread.param.sort[0].property = str)
    }
  }
}
</script>

